import { render, staticRenderFns } from "./EventContestTerms.vue?vue&type=template&id=a7cea7ce&scoped=true"
import script from "./EventContestTerms.vue?vue&type=script&lang=ts"
export * from "./EventContestTerms.vue?vue&type=script&lang=ts"
import style0 from "./EventContestTerms.vue?vue&type=style&index=0&id=a7cea7ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cea7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7cea7ce')) {
      api.createRecord('a7cea7ce', component.options)
    } else {
      api.reload('a7cea7ce', component.options)
    }
    module.hot.accept("./EventContestTerms.vue?vue&type=template&id=a7cea7ce&scoped=true", function () {
      api.rerender('a7cea7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestTerms.vue"
export default component.exports